export default __webpack_public_path__ + "static/media/Why Quit.d83e7263.png";